import { createFileRoute } from '@tanstack/react-router';

import { ExternalMainPage } from '../pages/main-page/external-main-page';

export const Route = createFileRoute('/entrypoint')({
  component: ExternalMainPage,
});
